<template>
  <div class="common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">年份：</div>
          <div class="content">
            <el-select v-model="form.year" placeholder="请选择">
              <el-option v-for="(item,index) in yearList" :key="index" :label="item" :value="item" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">状态：</div>
          <div class="content">
            <el-select v-model="form.stat" placeholder="请选择">
              <el-option v-for="item in stateList" :key="item.val" :label="item.label" :value="item.val" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">活动分类：</div>
          <div class="content">
            <el-select v-model="form.activityClassificationCode" placeholder="请选择">
              <el-option v-for="(item,index) in activityClassificationList" :key="index" :label="item.name" :value="item.value" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="addBtn">添加</el-button>
    </div>
    <commonTable ref="templateManagementTable" />
    <addTemplateActivity
      ref="addTemplateActivity"
      :row-data="rowData"
      :add-template-dialog-visible="addTemplateDialogVisible"
      :editable="rowData.editable === false ? true : false"
      @addTemplateSubHandle="addTemplateSubHandle"
      @editTemplateSubHandle="editTemplateSubHandle"
      @dialogCloseHandle="dialogCloseHandle"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import commonTable from '@/components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import addTemplateActivity from './component/templateActivityManagement/addTemplateActivity';
import { templateActivityApi } from './service';
import Cookies from 'js-cookie';
export default {
  data () {
    return {
      form: {
        year: null,
        activityClassificationCode: ''
      },
      yearList: [],
      stateList: [
        {
          label: '全部'
        },
        {
          label: '启用',
          val: 1
        },
        {
          label: '禁用',
          val: 0
        }
      ],
      activityClassificationList:[
        {
          name:'行业模板活动',
          value:'AC_01'
        },
        {
          name:'区域活动',
          value:'AC_02'
        },
      ],
      addTemplateDialogVisible: false,
      rowData: {}
    };
  },
  components: {
    commonTable,
    addTemplateActivity
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  methods: {
    statHandle (row) {
      let params = {
        id: row.id,
        stat: row.stat
      };
      // 活动议程数组处理
      params.activityAgenda = row.templateActivityAgendaList.map(item => {
        return {
          agenda: item.agenda,
          orderNum: item.orderNum
        };
      });
      this.$store.commit('setSubPageLoading', true);
      templateActivityApi.templateActivityUpdate(params).then(res => {
        if (res.status === '200') {
          this.loadTable();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    editHandlen (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.addTemplateDialogVisible = true;
    },
    deleteHandle (row) {
      this.$confirm('确定删除该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        templateActivityApi.templateActivityDel(row.id).then(res => {
          if (res.status === '200') {
            this.loadTable();
            this.$message.success('删除成功');
          }
        });
      }).catch(() => {

      });
    },
    editTemplateSubHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      templateActivityApi.templateActivityUpdate(data).then(res => {
        if (res.status === '200') {
          this.$message.success('编辑成功');
          this.addTemplateDialogVisible = false;
          this.loadTable();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    materialSunHandle (data) {
      templateActivityApi.getTicketEncrypt().then(res => {
        if (res.status === '200') {
          const ticket =  window.encodeURIComponent(res.data);
          const templateName = window.encodeURIComponent(data.templateNameEncrypt);
          const templateId = window.encodeURIComponent(data.idEncrypt);
          // const datas = window.encodeURIComponent(this.userInfo.emailEncrypt);
          this.$confirm('物料状态是否更新？')
          .then(_ => {
            this.loadTable();
          })
          .catch(_ => {
            this.loadTable();
          });
          window.open(`${window._env_.VUE_APP_HT_URL}/rjTemplate/rjEventTemplateConfig?templateName=${templateName}&templateId=${templateId}&data=${ticket}`);
        }
      })
    },
    addTemplateSubHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      templateActivityApi.templateActivityAdd(data).then(res => {
        if (res.status === '200') {
          this.$message.success('添加成功');
          this.addTemplateDialogVisible = false;
          this.loadTable();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    dialogCloseHandle () {
      this.rowData = {};
      this.addTemplateDialogVisible = false;
    },
    addBtn () {
      this.addTemplateDialogVisible = true;
      this.$refs.addTemplateActivity.formData = {
        visibleRangeSelect: [],
        visibleRange: '',
        activityClassification: '行业模板活动',
        activityClassificationCode: 'AC_01'
      };
    },
    reset () {
      this.form = {
        year: new Date().getFullYear()
      };
      this.searchBtn();
    },
    searchBtn () {
      this.$refs.templateManagementTable.pageData.pageNum = 1;
      this.$refs.templateManagementTable.getTableData({ url: '/template_activity/list', params: this.form });
    },
    getYearList () {
      let myDate = new Date();
      let thisYear = this.form.year = myDate.getFullYear();
      let Section = thisYear - 2021;
      let arrYear = [];
      for (let i = 0; i <= Section; i++) {
        arrYear.push(thisYear--);
      }
      this.yearList = arrYear;
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('活动分类')
          ._width('10%')
          ._data('activityClassification')
      );
      tableRow.push(
        new TableColumns()
          ._title('活动模板名称')
          ._width('20%')
          ._data('templateName')
      );
      // tableRow.push(
      //   new TableColumns()
      //     ._title('活动目的')
      //     ._width('8%')
      //     ._data('activityGoal')
      // );
      tableRow.push(
        new TableColumns()
          ._title('活动类型')
          ._width('8%')
          ._data('activityType')
      );
      tableRow.push(
        new TableColumns()
          ._title('更新时间')
          ._width('8%')
          ._data('updateTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd');
              return (
                <span>{ date }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('更新人')
          ._width('8%')
          ._data('updateUser')
      );
      tableRow.push(
        new TableColumns()
          ._title('物料状态')
          ._width('6%')
          ._data('materialStat')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  { row.materialStat ? '已配置' : '未配置' }
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('状态')
          ._width('6%')
          ._data('stat')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  {<el-switch v-model={row.stat} active-value={1} inactive-value={0} onChange={() => {this.statHandle(row);}}>
                  </el-switch>}
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('12%')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => { this.editHandlen(row); }}>
                    编辑
                  </el-button>
                  <el-button type="text" onClick={() => { this.materialSunHandle(row); }}>
                    物料配置
                  </el-button>
                  <el-button type="text" disabled={!row.editable} onClick={() => { this.deleteHandle(row); }}>
                    删除
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.templateManagementTable.setColumn(column);
      this.$refs.templateManagementTable.loadTable({ url: '/template_activity/list', listKey: 'list', params: this.form });
    }
  },
  mounted () {
    this.getYearList();
    this.loadTable();
  }
};
</script>

<style scoped>
.common_button {
  margin-bottom: 16px;
}
</style>
